var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyVetting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 138,
    viewBox: "0 0 270 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5919 74.886C12.5919 74.886 -2.6523 136.934 1.09188 137.766C4.83606 138.597 17.6738 76.4101 17.6738 76.4101L12.5919 74.886Z",
    fill: "#DEDFE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2149 74.843C62.2149 74.843 77.4592 136.891 73.715 137.723C69.9709 138.554 57.1331 76.3671 57.1331 76.3671L62.2149 74.843Z",
    fill: "#DEDFE3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00517 71.974C9.00517 71.974 4.80062 11.4355 5.31294 8.12135C5.82525 4.80719 23.6944 0.481911 31.2518 0.324199C38.8092 0.166488 44.3685 0.184167 47.1493 0.481903C50.0951 0.797327 66.8855 1.80846 67.8504 8.12135C68.8636 14.7519 64.8754 72.6048 64.8754 72.6048C64.8754 72.6048 46.5871 75.2874 35.3147 75.1297C27.2458 75.0176 9.00517 71.974 9.00517 71.974Z",
    fill: "#DEDFE3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4196 70.7639C10.4196 70.7639 8.05797 69.9746 6.30542 70.6062C4.55287 71.2377 4.1722 76.3663 6.38157 78.6546C8.59093 80.9429 20.9335 83.2312 36.9327 82.9158C52.9319 82.6004 65.4267 80.864 68.322 78.1815C71.2173 75.4989 68.9318 69.8169 65.732 70.133C62.5321 70.4485 55.2181 74.2365 38.1523 73.7626C21.0858 73.2895 12.0953 71.2377 10.4196 70.7639Z",
    fill: "#C2C4CC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.399 74.886C110.399 74.886 95.1547 136.934 98.8989 137.766C102.643 138.597 115.481 76.41 115.481 76.41L110.399 74.886Z",
    fill: "#DEDFE3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M160.022 74.843C160.022 74.843 175.266 136.891 171.522 137.723C167.778 138.554 154.94 76.3671 154.94 76.3671L160.022 74.843Z",
    fill: "#DEDFE3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.812 71.974C106.812 71.974 102.608 11.4355 103.12 8.12135C103.632 4.80719 121.501 0.481911 129.059 0.324199C136.616 0.166488 142.175 0.184167 144.956 0.481903C147.902 0.797327 164.692 1.80846 165.657 8.12135C166.671 14.7519 162.682 72.6048 162.682 72.6048C162.682 72.6048 144.394 75.2874 133.122 75.1297C125.053 75.0176 106.812 71.974 106.812 71.974Z",
    fill: "#DEDFE3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.226 70.7639C108.226 70.7639 105.865 69.9746 104.112 70.6062C102.36 71.2377 101.979 76.3663 104.188 78.6546C106.398 80.9429 118.74 83.2312 134.74 82.9158C150.739 82.6004 163.234 80.864 166.129 78.1815C169.024 75.4989 166.739 69.8169 163.539 70.133C160.339 70.4485 153.025 74.2365 135.959 73.7626C118.893 73.2887 109.903 71.237 108.226 70.7639Z",
    fill: "#C2C4CC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M208.206 74.886C208.206 74.886 192.961 136.934 196.706 137.766C200.45 138.597 213.288 76.4101 213.288 76.4101L208.206 74.886Z",
    fill: "#DEDFE3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M257.825 74.843C257.825 74.843 273.069 136.891 269.325 137.723C265.581 138.554 252.743 76.3671 252.743 76.3671L257.825 74.843Z",
    fill: "#DEDFE3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M204.623 71.974C204.623 71.974 200.418 11.4355 200.93 8.12135C201.443 4.80719 219.312 0.481911 226.869 0.324199C234.427 0.166488 239.986 0.184167 242.767 0.481903C245.713 0.797327 262.503 1.80846 263.468 8.12135C264.481 14.7519 260.493 72.6048 260.493 72.6048C260.493 72.6048 242.205 75.2874 230.932 75.1297C222.863 75.0169 204.623 71.974 204.623 71.974Z",
    fill: "#DEDFE3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M206.037 70.7639C206.037 70.7639 203.676 69.9746 201.923 70.6062C200.17 71.2377 199.79 76.3663 201.999 78.6546C204.208 80.9429 216.551 83.2312 232.55 82.9158C248.549 82.6004 261.044 80.864 263.94 78.1815C266.835 75.4989 264.549 69.8169 261.35 70.133C258.15 70.4485 250.836 74.2365 233.77 73.7626C216.703 73.2887 207.714 71.2377 206.037 70.7639Z",
    fill: "#C2C4CC"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 269.5,
    y1: 137.5,
    x2: 1.5,
    y2: 137.5,
    stroke: "#DEDFE3",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyVetting);
export default __webpack_public_path__ + "static/media/empty-vetting.eceee036258f9f45a3cdf866ec94153b.svg";
export { ForwardRef as ReactComponent };